var map = {
	"./skin1/order_form_image@3x.png": "13bf",
	"./skin2/order_form_image@3x.png": "6bb9",
	"./skin3/order_form_image@3x.png": "7bc3",
	"./skin4/order_form_image@3x.png": "5ced",
	"./skin5/order_form_image@3x.png": "89a0",
	"./skin6/order_form_image@3x.png": "9364"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c61b";